import * as React from 'react'
import Lottie from 'react-lottie'
import * as defaultAnimation from '../../atoms/dasher-excited/DasherExcitedAnimation.json'
import { OnboardingComponentProps } from '.'

const DEFAULT_ANIMATION_START_DELAY_MS = 750

export const AnimatedImageComponent: React.FC<OnboardingComponentProps> = ({
  width,
  height,
  autoplay,
  loop,
  data,
}) => {
  const [isStopped, setIsStopped] = React.useState<boolean>(true)
  React.useEffect(() => {
    setTimeout(() => {
      setIsStopped(false)
    }, DEFAULT_ANIMATION_START_DELAY_MS)
  }, [])

  return (
    <Lottie
      options={{
        autoplay,
        loop,
        animationData: data || defaultAnimation,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      }}
      height={height}
      width={width}
      isStopped={isStopped}
    />
  )
}
